module.exports = __webpack_public_path__ + "img/list_1_tc.44a61231.png";